<app-page-header
  [title]="org?.name ? org.name + ': Features' : 'Features'"
  [breadcrumbs]="breadcrumb"
></app-page-header>

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <app-features-form [orgTag]="orgTag"></app-features-form>
    </div>
  </div>
</section>
